<div style="position: fixed; top: 20px; right: 20px;z-index: 500;">
  <ori-toast-view
    (hidden)="remove(idx)"
    *ngFor="let item of items; let idx = index"
    [content]="item.content"
    [id]="item.id"
    [title]="item.title"
  ></ori-toast-view>
</div>
